
import { Room } from "../../types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteItem, fetchData, handleAddItem, handleGetDataByPost, handleUpdateItem } from "../../utils/data";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";
export const fetchRooms = createAsyncThunk("get/Rooms", async () => {
    const data = await fetchData(`Room/getRooms?lang=${lang}`);
    return data;
});
export const fetchRoomsByStays = createAsyncThunk("get/RoomsByStays", async ({ stayId, userId }: { stayId: number, userId: string }) => {
    const data = await fetchData(`Room/getRoomsByStay?stayId=${stayId}&userId=${userId}&lang=${lang}`, true);
    return data;
});
export const fetchRoomById = createAsyncThunk("get/RoomById", async ({ roomId, userId }: { roomId: number, userId: string }) => {
    const data = await fetchData(`Room/getRoomById?roomId=${roomId}&userId=${userId}&lang=${lang}`, true);
    return data;
});
export const addRoom = createAsyncThunk("post/Room", async (RoomData: any) => {
    await handleAddItem(RoomData, "Room/addRoom", "POST");
    return RoomData;
});
export const fetchAvailableRooms = createAsyncThunk("post/Rooms", async (searchData: any) => {
    const res = await handleGetDataByPost(searchData, `Room/getAvailableRooms?lang=${lang}`, "POST");
    return res;
});
export const updateRoom = createAsyncThunk("PUT/Room", async ({ id, data }: { id: number, data: any }) => {
    await handleUpdateItem(data, `Room/editRoom?roomId=${id}`, "PUT");
    return { ...data };
});
export const deleteRoom = createAsyncThunk("delete/Room", async (id: number) => {
    await deleteItem(`Room/deleteRoom?roomId=`, id);
    return id;
});
export const deleteRoomServicee = createAsyncThunk("delete/roomService", async ({ roomId, serviceId }: { roomId: number, serviceId: number }) => {
    await deleteItem(`Room/deleteRoomService?roomId=${roomId}&serviceId=`, serviceId,);
});

interface RoomState {
    Rooms: Room[];
    Room: Room | null;
    availableRooms: Room[];
    loading: boolean;
    error: string;
}

const initialState: RoomState = {
    Rooms: [],
    availableRooms: [],
    Room: null,
    loading: false,
    error: ""
};
const RoomSlice = createSlice({
    name: "RoomSlice",
    initialState,
    reducers: { },
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchRooms.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchRooms.fulfilled, (state, action) => {
                state.loading = false;
                state.Rooms = action.payload;
            })
            // Fetch rooms by stay
            .addCase(fetchRoomsByStays.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchRoomsByStays.fulfilled, (state, action) => {
                state.loading = false;
                state.Rooms = action.payload;
            })
            // Fetch rooms by id
            .addCase(fetchRoomById.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchRoomById.fulfilled, (state, action) => {
                state.loading = false;
                state.Room = action.payload;
            })
            // Fetch available rooms in hotel
            .addCase(fetchAvailableRooms.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchAvailableRooms.fulfilled, (state, action) => {
                state.loading = false;
                state.availableRooms = action.payload.data;
            })

    }
});

export default RoomSlice.reducer;